/**
 * Initialize all sliders on the document
 *
 */

import Glide from '@glidejs/glide'

export default function carouselInit() {
  const carouselElements = document.querySelectorAll('.carousel')

  carouselElements.forEach(carouselElement => {
    const glide = new Glide('.carousel', {
      type: 'carousel',
      focusAt: 0,
      startAt: 0,
      perView: 3,
      peek: 0,
      gap: 20,
      keyboard: false, //keyboard arrows controlled carousel even if it was not selected
      breakpoints: {
        [768]: {
          perView: 1,
        }
      }
    })

    glide.mount()
  });

}
